import React, { Component } from "react";
import Button from "../../../../../shared/button/button";
import { bindActionCreators } from "redux";
import { openOrCloseExportModal } from "../../../../actions/sales";
import connect from "react-redux/es/connect/connect";
import SalesListAllHeader from "./SalesListAllHeader";
import SalesListReceivedHeader from "./SalesListReceivedHeader";
import SalesListToReceiveHeader from "./SalesListToReceiveHeader";
import SalesListFrozenHeader from "./SalesListFrozenHeader";
import { findUserPayments } from "../../../../actions/util";
import ArrowLeft from "../../../../../shared/Arrows/ArrowLeft";
import ArrowRight from "../../../../../shared/Arrows/ArrowRight";
import Modal from "../../../../../shared/Modal/Modal";
import Select from "../../../../../shared/AtomicSelect";
import { getIRPFYears, exportIRPFToDownloadOffer } from "../../../../shared/requests-api";

class SalesListHeader extends Component {
	constructor(props) {
		super(props);
		this.state = {
			countScroll: 0,
			maxScrollRight: false,
			modalReceita: false,
			loadingYears: true,
			loadingDownload: false,
			errorYears: false,
			years: [],
			selectedYear: null
		};

		this.handleClickOutside = this.handleClickOutside.bind(this);
	}

	componentDidMount() {
		getIRPFYears()
			.then(response => {
				const data = response.data;
				const years = data.map(year => ({ value: year, label: year }));
				const selectedYear = data[years.length - 1];
				this.setState({ years, selectedYear });
			})
			.catch(() => {
				this.setState({ errorYears: true });
			})
			.finally(() => {
				this.setState({ loadingYears: false });
			});
	};

	handleSelectedYear = e => {
		this.setState({ selectedYear: e.target.value });
	};

	downloadIRPF = (type, year) => {
		this.setState({ loadingDownload: true });
		exportIRPFToDownloadOffer(type, this.state.selectedYear)
			.finally(() => {
				this.setState({ loadingDownload: false });
			});
	}

	prev = scrollIncrement => {
		let element = document.getElementById("sales-list-header__boxes");
		if (scrollIncrement < 0) {
			return;
		}

		element.scrollLeft = element.clientWidth / scrollIncrement;
		this.setState({
			countScroll: scrollIncrement,
			maxScrollRight: element.firstChild.childElementCount - 1 === scrollIncrement
		});
	};

	next = scrollIncrement => {
		let element = document.getElementById("sales-list-header__boxes");
		if (scrollIncrement >= element.firstChild.childElementCount) {
			return;
		}

		element.scrollLeft = element.clientWidth * scrollIncrement;
		this.setState({
			countScroll: scrollIncrement,
			maxScrollRight: element.firstChild.childElementCount - 1 === scrollIncrement
		});
	};

	renderMarkers = () => {
		let element = document.getElementById("sales-list-header__boxes");
		if (!element || !element.firstChild) {
			return false;
		}

		let markers = [];
		for (let x = 0; x < element.firstChild.childElementCount; x++) {
			markers.push({ value: x + 1 });
		}
		return markers.map((marker, index) => {
			return (
				<div
					key={marker.value}
					className={`sales-list-header__boxes__markers--marker${this.state.countScroll === index
						? " sales-list-header__boxes__markers--marker--active"
						: ""
						}`}
				/>
			);
		});
	};

	handleReceitaModal = () => {
		this.setState({ modalReceita: !this.state.modalReceita });
	};

	handleClickOutside(event) {
		if (!this.receitaMenuInst.contains(event.target)) this.handleReceitaModal();
	}

	clickOnDownloadReceita = (ev, type) => {
		this.props.downloadIRPF(ev, type);
	};

	render() {
		return (
			<div
				className={`sales-list-header${this.state.countScroll === 0
					? " sales-list-header--max-left"
					: `${this.state.maxScrollRight ? " sales-list-header--max-right" : ""}`
					}`}
			>
				<h1 className="sales-list-header--header">Minhas Vendas</h1>
				<label className="sales-list-header--label-title">
					{this.props.filteredStatements.status === 0 && "TODAS AS TRANSAÇÕES:"}
					{this.props.filteredStatements.status === 1 && "TRANSAÇÕES RECEBIDAS:"}
					{this.props.filteredStatements.status === 2 && "TRANSAÇÕES A RECEBER:"}
					{this.props.filteredStatements.status === 3 && "TRANSAÇÕES CANCELADAS:"}
					{this.props.filteredStatements.status === 4 && "TRANSAÇÕES REVENDIDAS:"}
					{this.props.filteredStatements.status === 5 && "OUTRAS TRANSAÇÕES:"}
					{this.props.filteredStatements.status === 6 && "PAGAMENTOS CONGELADOS:"}
				</label>
				<div className="sales-list-header__boxes">
					<div className="sales-list-header__boxes__content">
						{this.props.filteredStatements.status < 3 && (
							<ArrowLeft
								className="sales-list-header__boxes__content--arrow-left"
								onClick={e => this.prev(this.state.countScroll - 1)}
							/>
						)}
						<div
							id="sales-list-header__boxes"
							className="sales-list-header__boxes__content__values"
						>
							{this.props.filteredStatements.status === 0 && (
								<SalesListAllHeader
									valueTotalReceived={this.props.sales.totalRecived}
									valueTotalToReceive={this.props.sales.totalToRecive}
									valueTotalFrozen={this.props.sales.totalFrozen}
									isFetching={this.props.isFetching}
									totalMiles={this.props.sales.totalMiles}
									isDecimal={true}
								/>
							)}

							{this.props.filteredStatements.status === 1 && (
								<SalesListReceivedHeader
									value={this.props.sales.totalRecived}
									isFetching={this.props.isFetching}
									startFilteredDate={this.props.filteredStatements.start}
									endFilteredDate={this.props.filteredStatements.end}
									totalMiles={this.props.sales.totalMiles}
									isDecimal={true}
								/>
							)}

							{this.props.filteredStatements.status === 2 && (
								<SalesListToReceiveHeader
									findUserPayments={this.props.findUserPayments}
									userPayments={this.props.userPayments}
									totalMiles={this.props.sales.totalMiles}
									isDecimal={true}
								/>
							)}

							{this.props.filteredStatements.status === 6 && (
								<SalesListFrozenHeader 
									valueTotalFrozen={this.props.sales.totalFrozen}
									isFetching={this.props.isFetching}
								/>
							)}
						</div>
						{this.props.filteredStatements.status < 3 && (
							<ArrowRight
								className="sales-list-header__boxes__content--arrow-right"
								onClick={e => this.next(this.state.countScroll + 1)}
							/>
						)}
					</div>
					<div className="sales-list-header__boxes__markers">{this.renderMarkers()}</div>
				</div>
				<div className="sales-list-header--area-export-button">
					<Button
						onClick={this.props.openOrCloseExportModal}
						className="btn-gray-md sales-list-header--export-button margin-right"
						data-action="sales-list-header-export"
					>
						<i className="icon-export" />
					</Button>

					<Button
						onClick={this.handleReceitaModal}
						className="btn-gray-md sales-list-header--irpf-export-button margin-left"
						data-action="sales-list-header-export"
						disabled={this.state.loadingYears || this.state.errorYears || !this.state.years.length}
					>
						<i className="icon-irpf" />
					</Button>
				</div>

				<Modal
					cancel
					useButton
					title="Exporte sua declaração"
					confirm="Download em Excel"
					confirmTwo="Download em CSV"
					show={this.state.modalReceita}
					onCancel={() => this.setState({ modalReceita: false })}
					onConfirm={() => this.downloadIRPF('xlsx', this.state.selectedYear)}
					onConfirmTwo={() => this.downloadIRPF('csv', this.state.selectedYear)}
					disabledConfirm={this.state.loadingDownload}
					disabledConfirmTwo={this.state.loadingDownload}
					fixed={true}
					width={529}
				>
					<label for="year">Selecione o ano da declaração</label>
					<Select
						name="year"
						id="year"
						options={this.state.years}
						onChange={this.handleSelectedYear}
						defaultValue={this.state.selectedYear}
						disabled={this.state.loadingDownload}
					/>
				</Modal>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	sales: state.mySales.salesData,
	filteredStatements: state.mySales.filteredStatements,
	isFetching: state.mySales.isFetching,
	isIRPFFetching: state.mySales.isIRPFFetching,
	userPayments: state.util.userPayments
});
const mapDispatchToProps = dispacth =>
	bindActionCreators(
		{
			openOrCloseExportModal,
			findUserPayments
		},
		dispacth
	);
export default connect(mapStateToProps, mapDispatchToProps)(SalesListHeader);
